/*
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-14 09:55:51
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-17 11:33:07
 */
// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
	// images: {
	// 	listUploadBtn: '../../public/static/images/list-uploadBtn-zh.png'
	// },
	works: {
		text: '亲爱的小朋友们，2022年2月4日，北京冬奥会就要开幕啦！中央广播电视总台CGTN俄语部与今日俄罗斯国际通讯社共同发起“童心冬奥”中俄儿童创意画征集活动。如果你的年龄没有超过15岁，我们向你发出邀请！请你发挥想象力，用画笔绘出自己心中的北京冬奥会。本次活动还得到了莫斯科中国文化中心和北京俄罗斯文化中心的大力支持！让我们一起寄语奥林匹克精神，祝福北京冬奥会取得圆满成功！'
	},
	uploadWork: {
		workName: '作品名称',
		creator: '创作者',
		age: '年龄',
		nationality: '国籍',
		buttonInfo: '确认上传',
		uploadInfo: '上传作品',
		uploadMsg: '建议图片格式为JPG,图片大小不超过5MB,每次最多上传一张',
		inputMsg: '请输入中文或俄文'
	},
	work: {
		logo: '',
		workName: '作品名称',
		creator: '创作者',
		age: '年龄',
		nationality: '国籍',
		buttonInfo: '更多作品'
	}
}
